export function getProjectInfo(payload) {
  return { type: 'GET_PROJECT_BASIC_INFO', payload };
}

export function projectInfoError(payload) {
  return { type: 'PROJECT_BASIC_INFO_ERROR', payload };
}
